import { render, staticRenderFns } from "./OfficeGalleryComponent.vue?vue&type=template&id=751394c2&scoped=true&"
import script from "./OfficeGalleryComponent.vue?vue&type=script&lang=js&"
export * from "./OfficeGalleryComponent.vue?vue&type=script&lang=js&"
import style0 from "./OfficeGalleryComponent.vue?vue&type=style&index=0&id=751394c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751394c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('751394c2')) {
      api.createRecord('751394c2', component.options)
    } else {
      api.reload('751394c2', component.options)
    }
    module.hot.accept("./OfficeGalleryComponent.vue?vue&type=template&id=751394c2&scoped=true&", function () {
      api.rerender('751394c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/office/OfficeGalleryComponent.vue"
export default component.exports